// @ts-ignore
import DateFormatNative from "./sap/ui/core/format/DateFormat.js";
const DateFormatWrapped = DateFormatNative;
class DateFormat extends DateFormatWrapped {
}
export default DateFormat;
//# sourceMappingURL=DateFormat.js.map